/**
 * Legacy DonationsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.donationsApi`) keep resolving.
 *
 * The actual DonationsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/donations/donations-api.service.ts
 */
angular.module("acme.common.service.donationsApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
